/**
 * Shared `<select>` appearance for SRP sort and "last seen" recency controls.
 *
 * Avoids `@container` / `@sm:` breakpoint steps on the control itself: when the SRP island
 * swaps from the static shell (`#srp-ssr`) to in-flow `#srp-app`, container width and
 * scrollbar metrics can change slightly and retoggle those variants — causing visible jump.
 * `transition-colors` avoids animating width. Width stays content-driven (`inline-block w-auto`);
 * optional wrappers may set `max-w-*` where a cap is needed.
 */
const SRP_INLINE_SELECT_BASE =
  'inline-block w-auto max-w-full min-w-0 rounded-lg border border-[#DDD5C8] dark:border-[#4A3520] bg-white dark:bg-[#1F1509] px-3 py-2 text-sm font-medium text-[#1E1A14] dark:text-[#F2EADF] shadow-sm dark:shadow-none focus:outline-none focus:ring-2 focus:ring-[#3B5E45] dark:focus:ring-[#98CFA8] transition-colors duration-200 truncate';

/** Interactive sort / recency dropdowns */
export const SRP_INLINE_SELECT_CLASSNAME = `${SRP_INLINE_SELECT_BASE} cursor-pointer`;

/** Non-interactive replica (e.g. static SSR sidebar placeholder). */
export const SRP_INLINE_SELECT_STATIC_CLASSNAME = `${SRP_INLINE_SELECT_BASE} cursor-default`;
